export const SETTINGS_TABS = [
  // { id: "profile", label: "Profile" },
  { id: "design", label: "Design" },
  { id: "billing", label: "Billing" },
];
